import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import Icon   from 'app/components/common/icon';
import Select from 'app/components/common/select';
import {
  PaymentMethodTypes,
}             from 'app/constants';


class PaymentMethodInput extends React.PureComponent {

  constructor(props) {
    super(props);

    this.renderPaymentMethodOption = this.renderPaymentMethodOption.bind(this);
  }

  renderPaymentMethodOption(pm, isSelected) {
    if (!pm) return (
      <span className="faint">{this.props.label}</span>
    );
    const isBalance = pm === this.props.balanceObj;
    const isCc = pm.type === PaymentMethodTypes.CREDIT_CARD;
    const PmIcon = (() => {
      if (isCc) return Icon.CreditCard;
      if (isBalance) return Icon.MoneyWalletOpen;
      return Icon.SavingBank;
    })();
    return (
      <div className={`payment-select-option ${isSelected ? 'selected' : ''}`}>
        <PmIcon brand={pm.brand} />
        <span>{pm.name}</span>
      </div>
    );
  }

  render() {
    const { paymentMethods, className, onSelect, selectedPaymentMethod: selectedPm, balanceObj } = this.props;

    return (
      <Select
        className={`payment-select ${className}`}
        options={[...paymentMethods, ...(balanceObj ? [balanceObj] : [])]}
        renderOption={this.renderPaymentMethodOption}
        onSelect={onSelect}
        selectedOption={selectedPm}
      />
    );
  }

}

PaymentMethodInput.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  paymentMethods: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedPaymentMethod: PropTypes.object,
  onSelect: PropTypes.func.isRequired,
  balanceObj: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
};

PaymentMethodInput.defaultProps = {
  label: 'Payment Method...',
  className: '',
  selectedPaymentMethod: null,
};

export default PaymentMethodInput;
